import React from 'react';
import './LessonAttachment.scss';
import SvgIcons from '../../../../services/SvgIcons';
import Skeleton from '../../../../components/Skeleton/Skeleton';

export default function LessonAttachment({ selectedTrainingLesson, lessonMediaUrl }) {

    return (
        <>
            {
                selectedTrainingLesson ?
                    selectedTrainingLesson.attachments && selectedTrainingLesson.attachments.length > 0 &&
                        <div className='training-lesson-attachment'>
                            <span className='training-lesson-attachment__title'>RESSOURCES</span>
                            <ul className='training-lesson-attachment__list'>
                                {
                                    selectedTrainingLesson.attachments.map((attachment) => (
                                        <li key={attachment.id} className='training-lesson-attachment__list_item'>
                                            <a
                                                href={lessonMediaUrl(attachment.file)}
                                                className='training-lesson-attachment__list_item_link'
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                download
                                            >
                                                <SvgIcons
                                                    name={'download'}
                                                    color='#361215'
                                                    width={32}
                                                    height={32}
                                                    marginRight={'10px'}
                                                />
                                                <span>{attachment.title + ' (' + attachment.type.toUpperCase().slice(1) + ')'}</span>
                                            </a>
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>
                :
                    <Skeleton
                        width='100%'
                        height='300px'
                        borderRadius='1rem'
                        bkgColor='#EEE6DB'
                        animColor='#F5F0ED'
                    />
            }
        </>
    )
}